import { render } from "./Video.vue?vue&type=template&id=4a47fa34&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=4a47fa34&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a47fa34"]])

export default __exports__